/**
 * Sort Directions for seacrh api
 * Api will decide to sort Asc or desc based on asbv Best to worst direction field
 */
export enum SortDir {
  BestToWorst = 0,
  WorstToBest = 1
}
